import React from 'react';
import landingImage from './image/landing.svg';
import landing1Image from './image/landing1.svg';
import landing2Image from './image/awards5.svg';
import './Landing.css';

const Landing = () => {
  return (
    <div className="landing-bg">
      <div className="landing-row">
        {/* First Item: Image with Text */}
        <div className="landing-item">
          <img src={landingImage} alt="Award 1" className="landing-image" />
          <div className="text-content">
            <p className="image-text">
              <strong>National Award</strong> given to Nashabandi Mandal Maharashtra<br />
              <span>By President of India</span><br />
              Ministry of Social Justice & Empowerment
            </p>
          </div>
        </div>

        {/* Second Item: Image with Text */}
        <div className="landing-item">
          <img src={landing1Image} alt="Award 2" className="landing-image" />
          <div className="text-content">
            <p className="image-text">
              <strong>Shahu, Phule, Ambedkar Award - 2019</strong> <br />
              Social Welfare Department <br />
              Government of Maharashtra <br />
              <br />
            </p>
          </div>
        </div>

        {/* Third Item: Image with Text */}
        <div className="landing-item">
          <div className="breaking-news">
            <p className="br-text">
              <strong>Breaking News: Latest</strong> <br />
            </p>
          </div>
          <img src={landing2Image} alt="Award 3" className="landing-image" />
          <div className="text-content">
            <p className="image-text">
              <strong>Women for Change Award</strong> <br />
              - Presented to Varsha Vidhya Vilas <br />
              <br />
              <br />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;
